<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
            <div class="title">
              {{ title }}
              <el-button class="title_btn" type="danger" @click="tableDel()">삭제</el-button>
              <el-button type="primary" class="title_btn" @click="$router.push(`/popup/detail`)">팝업등록</el-button>
              <div class="info">각 타입의 기간이 속한 제일 마지막에 등록한 사용중인 팝업만 노출됩니다.</div>
              <div class="clear"></div>
            </div>
            <div class="table_wrap">
              <div class="table_search">
                <el-row>
                  <el-col :span="12" :xs="24" :sm="24" :md="12" :xl="12" :lg="12">
                    <span class="t_s_title">검색</span>
                    <el-select
                      v-model="tableSelected"
                      placeholder="Select"
                      class="table_s_select"
                    >
                      <el-option
                        v-for="(item, index) in searchOptions"
                        :key="index"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <el-input class="table_s_input"
                              v-model="tableSearch"
                              size=""
                              prefix-icon="el-icon-search"
                              placeholder="검색어를 입력해주세요."
                    />
                  </el-col>
                  <el-col :span="12" :xs="24" :sm="24" :md="12" :xl="12" :lg="12">
                    <span class="t_s_title">등록기간</span>
                    <el-date-picker
                      v-model="filterCreateDate"
                      type="daterange"
                      range-separator="~"
                      value-format="yyyy-MM-dd"
                      start-placeholder="시작날짜"
                      end-placeholder="끝 날짜">
                    </el-date-picker>
                  </el-col>
                </el-row>
              <!-- <el-button type="text" size="large" class="toggle_title" @click="detailSearch = !detailSearch">
                <i class="el-icon-circle-plus-outline" v-show="!detailSearch"></i>
                <i class="el-icon-remove-outline" v-show="detailSearch"></i>
                상세검색
              </el-button>
              <div class="toggle_wrap" v-show="detailSearch">
                <el-row>

                </el-row>
              </div>  -->
            </div>
              <div class="search_btn_wrap text_center">
                <el-button type="primary" @click="[getList(), page=1]">검색</el-button>
              </div>
            <el-table
              :data="tableFilter.slice(pagnation.size * (page - 1 ), pagnation.size * page)"
              style="width: 100%"
              empty-text="데이터가 없습니다."
              @cell-click="cellClick"
              @selection-change="tablechkChange"
              v-loading="tableLoading"
            >
              <!-- <el-table-column
                class="table_no"
                type="index"
                label="번호"
                width="100"
                class-name="num"
                :index="tableIndex"
              >
              </el-table-column> -->
              <el-table-column
                type="selection"
                width="55"
                class-name="text-center"
                >
              </el-table-column>

              <el-table-column
                v-for="(header, index) in tableHeader"
                :key="index"
                :label = header.label
                :width = header.width
                :class-name="`${header.class}`"
                :cell="header.prop"
              >
                <template slot-scope="scope">
                  <div
                    :class="{'has_cursor': header.hasClickable}"
                  >
                    <span
                      v-for="(prop, index) in header.prop"
                      :key="index"
                    >
                      <div class="table_img" v-if="prop === 'img'">
                        <div class="table_img" v-if="scope.row.Team.File"
                          :style="`background-image: url(${scope.row.Team.File[0].thumb_url})`"></div>
                      </div>
                      <span
                        v-else
                      >
                        {{$_.result(scope.row, prop)}}
                        <span v-if="index+1 != header.prop.length">/</span>
                      </span>
                    </span>
                    {{header.after_txt}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-if="tableoption"
                               align="center"
                               width="150"
                               label="옵션"
                               class-name="table_bottons"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="warning"
                    @click="goDetail(scope.$index, scope.row)">수정</el-button>
                  <!-- <el-button
                    size="mini"
                    type="danger"
                    @click="tableDel(scope.$index, scope.row)">삭제</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagnation_wrap" v-show="filterPagnation.total">
            <el-pagination
              :page-size = filterPagnation.size
              :pager-count = filterPagnation.pagerCount
              layout="prev, pager, next"
              :current-page.sync = page
              :total="filterPagnation.total"
            >
            </el-pagination>
          </div>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
  import VuxAlert from '@/mixins/vux-alert';
  import util from '@/mixins/util';
  import validator from "@/mixins/validator";
  let params = {};
    export default {
        name: 'Popup',
        components: {
        },
        mixins: [ VuxAlert ,validator],
        data() {
          return{
            title: this.$route.meta.title,
            tableSearch: '',
            detailSearch: true,
            filterCreateDate: '',
            tableHeader: [
              {
                label : '팝업상태',
                prop : ['p_is_display_name'],
                width: 100,
                class: 'text_center',
              },
              {
                label : '팝업타입',
                prop : ['p_type_name'],
                width: 100,
                class: 'text_center',
              },
              {
                label: '팝업제목',
                prop: ['p_title'],
                class: 'text_center',
              },
              {
                label: '등록일자',
                prop: ['created_at'],
                width: 150,
                hasClickable: true,
                class: 'text_center',
              },
              {
                label: '팝업기간',
                prop: ['during_date'],
                class: 'text_center',
              },
            ],
            tableoption: true,
            pagnation: {
              size: 10,
              pagerCount: 11,
              page: 1,
            },
            page : 1,
            tableSelected: '',
            searchOption: 'ti',
            searchOptions: [
              {
                label: '제목',
                value: 'ti'
              }
            ],
            tableLoading: true,
            tableData: [],
            choiceRow: [],
          }
        },
        mounted() {
          this.getList();
        },
        computed: {
          tableFilter() {
            return this.tableData
          },
          filterPagnation() {
            return {
              size: 10,
              pagerCount: 11,
              total: this.tableFilter.length,
              page: 1
            }
          }

        },
        methods: {
          initData(){
            this.tableData =  [];
            this.tableLoading = true;
            this.page = 1;
          },
          getList() {
            params = {
              page: this.page,
              ip : 1,

            }

            if(this.tableSearch != '') {
              params[this.tableSelected] = this.tableSearch
            }

            if(this.filterCreateDate != ''){
              params.crsd = this.filterCreateDate[0];
              params.cred = this.filterCreateDate[1];
            }

            this.$api.$popup.getPopupList(params).then( res => res.Data.Result).then(res => {
              if(res.Info.Type === 1) {
                this.tableData = res.List;
                this.tableData.forEach(data => {
                  data.during_date = `${data.p_start} ~ ${data.p_end}`;
                  let today = new Date();
                  today = Date.parse(today);
                  let endDate = new Date(data.p_end);
                  endDate = Date.parse(endDate);
                  if(today > endDate) {
                    data.p_is_display = 3;
                  }
                  data.p_is_display_name = data.p_is_display === 0? '대기' : data.p_is_display === 1 ? '사용중' : '완료'
                  data.p_type_name = data.p_type === 1 ? 'PC' : '모바일';
                })
              }else{
                this.tableData = [];
                this.page = 1;
                this.lastPage = 0;
                this.listTotal = 0;
              }

              this.tableLoading = false;
            });
          },
          resetPage() {
            this.page = 1
          },
          cellClick(row, column, cell, event) {
            let label = column.label;
            let me = this;
            let clickHeader = {};
            this.tableHeader.forEach(header => {
              if(header.label === label) {
                clickHeader = header;
              }
            })
            if(clickHeader.hasClickable) {
              let url = clickHeader.goDetailUrl + this.$_.result(row, clickHeader.goDetailProp);
              //let v_idx = this.$_.result(row, clickHeader.goDetailProp);
              this.$router.push(url);
            }
          },
          goDetail(index, row) {
            this.$router.push('/popup/detail/' + row.p_idx);
            // window.open(`${location.protocol}//${location.host}/popup/detail/${row.p_idx}`)
          },
          tablechkChange(val) {
            this.choiceRow = val;
          },
          tableDel() {
            if(this.choiceRow.length === 0){
              this.createAlert({
                title: '알림',
                content: '체크박스를 선택해주세요',
                btnText: '확인',
              });
            }else{
              let alertParams = {'element' : this, 'key': ''};
              this.listDeleteAlert(alertParams);
            }
          },
          async dataDelete() {
            let alertTxt = {
              title: '확인',
              content: '전부 삭제 성공'
            };
            this.tableLoading = true;
            this.choiceRow.forEach(row => {
              params = {
                p_idx : row.p_idx
              }
              this.$api.$popup.deletePopup(params).then( res => res.Data.Result).then(res => {
                if(res.Info.Type === 1){
                  this.page = 1
                }else{
                  alertTxt.title = '알림'
                  alertTxt.content = '전부 삭제 실패'
                }
              });
            });

            setTimeout(() => {
              this.createAlert({
                title: alertTxt.title,
                content: alertTxt.content,
                btnText: "확인",
                func : this.getList()
              });
            }, 1000)
            this.tableLoading = false;
          }
        }
    }
</script>
